<gp-modal #deleteContractModal gp-modal="deleteContractModal" [closable]="true" size="sm">
  <div class="gp-modal-title" style="max-width: 90%">
    <h5 class="text-ellipsis">
      <i *ngIf="isSelectStep() || isConfirmStep()" class="fa-solid fa-diamond-exclamation text-danger"></i>
      <i *ngIf="isConflictStep()" class="fa-solid fa-triangle-exclamation text-warning"></i>
      <small class="m-l-xs">
        <strong *ngIf="isSelectStep()">{{ 'DIALOG.choose_contract_to_delete' | translate }}</strong>
        <strong *ngIf="isConfirmStep()">{{ selectedTranslateKeys.title | translate }}</strong>
        <strong *ngIf="isConflictStep()">{{ 'DIALOG.delete_employee_conflict' | translate }}</strong>
      </small>
    </h5>
  </div>
  <div class="gp-modal-body">
    <ng-container *ngIf="isSelectStep()">
      <div class="form-group" *ngFor="let contract of contracts">
        <label class="checkbox">
          <input type="checkbox" (click)="toggleContract(contract)">
          <img class="flag-icon" alt="flag" *ngIf="contract.flag" src="{{ contract.flag.href }}"/>
          <span>
          {{ 'EMPLOYEE_FORM.Contract_name' | translate:{name: contract.cliRegNickName} }}
            {{ formatContractDates(contract) }}
        </span>
        </label>
      </div>
    </ng-container>
    <p *ngIf="isConfirmStep()">{{ selectedTranslateKeys.text | translate }}</p>
    <p *ngIf="isConflictStep()">{{ 'DIALOG.delete_contract_conflict_detail' | translate }}</p>
  </div>
  <div class="gp-modal-footer">
    <button class="btn btn-danger p-x-md"
            test-id="delete-contract-modal-delete-btn"
            [disabled]="selectedContracts.length <= 0"
            (click)="deleteContracts()"
            *ngIf="isSelectStep()">
      {{ 'FORMS.delete' | translate }}
    </button>
    <button *ngIf="isConfirmStep()"
            type="button"
            class="btn btn-danger p-x-md"
            test-id="delete-contract-modal-confirm-btn"
            [disabled]="deleteIsLoading"
            (click)="confirmDeleteContracts(deleteContractModal)">
      {{ 'FORMS.confirm' | translate }}
      <i class="fa fa-light fa-spinner fa-spin" *ngIf="deleteIsLoading"></i>
    </button>
    <button type="button"
            class="btn btn-secondary p-x-md"
            test-id="delete-contract-modal-cancel-btn"
            (click)="close(deleteContractModal)"
            *ngIf="isSelectStep() || isConfirmStep()">
      {{ 'FORMS.cancel' | translate }}
    </button>
    <button *ngIf="isConflictStep()"
            type="button"
            class="btn btn-dark p-x-md"
            test-id="delete-contract-modal-close-btn"
            (click)="close(deleteContractModal)">
      OK
    </button>
  </div>
</gp-modal>
